{
  "version": 1,
  "asset_id": "fcd48a2e-dd02-4783-b967-ac12643f37ae",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/fcd48a2e-dd02-4783-b967-ac12643f37ae/cover-800.webp",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/fcd48a2e-dd02-4783-b967-ac12643f37ae/cover-800.webp",
  "original_filename": "cover-800.webp",
  "size": 40560,
  "content_type": "image/webp",
  "created_at": "2026-06-25T01:16:03Z"
}
